import { ILink } from '../caremap/WithLinks';

export type MemoryCategory =
    | 'preference'
    | 'health-observation'
    | 'routine'
    | 'event-incident'
    | 'logistics'
    | 'living-situation'
    | 'caregiver-wellbeing'
    | 'relationship-dynamic';

export type MemorySourceType = 'recording' | 'chat' | 'synthesis' | 'user';
export type MemoryLevel = 'observation' | 'synthesized';

// The mediaType MemoriesModel requests/sends and the api's MemoryFormatter returns.
export const memoryMediaType = 'application/vnd.innerhive.memory.v1+json';

// Mirrors the api's memory response shape (api/src/memory/MemoryFormatter.ts's formatForResponse).
// The api's own IMemoryItem (api/src/memory/model.ts) additionally carries scopeKey/derivedFrom/
// salience/invalidatedBy/invalidatedReason/supersedes/validUntil/nature, but the formatter strips
// those before the response reaches the app -- every row this formatter ever returns is active.
export interface IMemory {
    memoryId: string;
    category: MemoryCategory;
    fact: string;
    sourceType: MemorySourceType;
    sourceId: string;
    sourceDate: string;
    recordedBy: string;
    createdAt: string;
    updatedAt: string;
    active: boolean;
    level?: MemoryLevel;
    links: {
        self: ILink;
        delete: ILink;
        edit: ILink;
    };
}
